module.exports = __webpack_public_path__ + "static/media/41.18e8f243.png";